//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 引入公共组件
import {mapState, mapActions, mapGetters} from 'vuex';

export default {
    data() {
      return {
        unfold:false
      }
    },
    methods: {
      ...mapActions({
        setHeaderThree: 'setHeaderThree'
      }),
      changeUnfold(){
        this.unfold = !this.unfold;
      },
      toBank(){
        this.$router.push({path: '/home/schoolBank', query: {level: 3}});
        this.setHeaderThree('');
        this.headerName = "题库";
        this.unfold = false;
      },
      clearUnfold(){
        this.unfold = false;
      }
    }
}



// WEBPACK FOOTER //
// ./src/components/common/help.vue